var define = undefined;
var qs = require('querystring');

function query(urlKey, url, params) {
    var params = params || {};
    params[urlKey] = url;
    return '?' + qs.encode(params);
};

var shareProviders = {
    google: {
        url: 'https://plus.google.com/share',
        query: query.bind(null, 'url')
    },
    facebook: {
        url: 'https://www.facebook.com/sharer/sharer.php',
        query: query.bind(null, 'u')
    },
    twitter: {
        url: 'https://twitter.com/home',
        query: query.bind(null, 'status')
    },
    linkedIn: {
        url: 'https://www.linkedin.com/shareArticle',
        query: query.bind(null, 'url')
    },
    pinterest: {
        url: 'https://pinterest.com/pin/create/button/',
        query: query.bind(null, 'url')
    },
    email: {
        url: 'mailto:',
        query: query.bind(null, 'body')
    }
};

function getShareUrl(provider, url) {
    provider = shareProviders[provider];
    return provider.url + provider.query(url);
}

module.exports = getShareUrl;



// WEBPACK FOOTER //
// ./src/js/share/getShareUrl.js